<template>
  <form-label
    :label="label"
    :class-name="formLabelClassName"
  >
    <template #label>
      <slot name="label" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #body>
      <fieldset class="pega-welcome-questions-wrap">
        <template v-for="(option, i) in options">
          <label
            :key="i"
            class="pega-input pega-questions-column"
          >
            <input
              :data-test="`option-${i}`"
              type="checkbox"
              :value="option.id"
              name="form-item-group"
              :checked="value.includes(option.id)"
              @change="update"
            ><span>
              {{ option.name }}
            </span>
          </label>
        </template>
      </fieldset>
    </template>
    <template #error>
      <slot name="error" />
    </template>
  </form-label>
</template>

<style scoped>
input {
  cursor: pointer;
}
</style>

<script>
import FormLabel from '@/components/atoms/FormLabel'

export default {
  components: {
    FormLabel
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    formLabelClassName: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      values: this.value
    }
  },
  watch: {
    value (val) {
      this.$set(this, 'values', val)
    }
  },
  methods: {
    update (e) {
      if (e.target.checked) {
        this.values.push(Number(e.target.value))
      } else {
        this.values = this.values.filter(v => v !== Number(e.target.value))
      }
      this.$emit('input', this.values)
      this.$emit('change', this.values)
    }
  }
}
</script>
